import {Route, Routes } from "react-router-dom";
import Labs from "./Labs";

export default function StaffIndexRouter() {
  return (
    <Routes>
      <Route path="labs" element={<Labs />} />
    </Routes>
  )
}